import { formatearMoneda } from './numeros'

export const TIPOS_DOCUMENTO = {
  factura: 'Factura',
  factura_exenta: 'Factura exenta',
  boleta: 'Boleta',
  boleta_honorarios: 'Boleta de honorarios',
  nota_credito: 'Nota de crédito',
  recibo: 'Recibo',
  sin_documento: 'Sin documento',
  otro: 'Otro',
}

export const MEDIOS_PAGO = {
  efectivo: 'Efectivo',
  transferencia: 'Transferencia',
  tarjeta_credito: 'Tarjeta de crédito',
  tarjeta_debito: 'Tarjeta de débito',
  cheque: 'Cheque',
  otro: 'Otro',
}

export const ESTADOS_PAGO = {
  pendiente: {
    etiqueta: 'Pendiente',
    clase: 'bg-amber-100 text-amber-700',
  },
  parcial: {
    etiqueta: 'Pago parcial',
    clase: 'bg-blue-100 text-blue-700',
  },
  pagado: {
    etiqueta: 'Pagado',
    clase: 'bg-emerald-100 text-emerald-700',
  },
}

export function formatearTipoDocumento(valor) {
  return TIPOS_DOCUMENTO[valor] || valor || 'Sin especificar'
}

export function formatearMedioPago(valor) {
  if (!valor) return 'Sin especificar'

  return MEDIOS_PAGO[valor] || valor
}

export function obtenerEstadoPago(valor) {
  return (
    ESTADOS_PAGO[valor] || {
      etiqueta: valor || 'Sin estado',
      clase: 'bg-slate-100 text-slate-600',
    }
  )
}

// Reutiliza el helper central de numeros.js — ver ahí la regla de
// presentación (oculta ,00 pero nunca oculta centavos reales). Este
// helper también formatea las tarjetas de Dashboard que muestran montos
// de ventas POS (ventasPos, cobradoPos, etc.), así que hereda la misma
// regla aunque el nombre haga referencia a "gasto".
export function formatearMontoGasto(monto) {
  return formatearMoneda(monto)
}

export function formatearFechaGasto(fechaTexto) {
  if (!fechaTexto) return '—'

  const [anio, mes, dia] = fechaTexto.split('-')

  if (!anio || !mes || !dia) return '—'

  return `${dia}-${mes}-${anio}`
}

export function formatearFechaHora(valor) {
  if (!valor) return '—'

  const fecha = new Date(valor)

  if (Number.isNaN(fecha.getTime())) return '—'

  return fecha.toLocaleString('es-CL', {
    dateStyle: 'short',
    timeStyle: 'short',
  })
}
